export default __webpack_public_path__ + "static/media/provider_duration.716c4f07.svg";